module.exports = __webpack_public_path__ + "img/Card_diamond_4.9d0bd85a.svg";